// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopPaymentControllerCheckPaymentStatusData } from './EshopPaymentControllerCheckPaymentStatusData.gen';
import type { EshopPaymentControllerCheckPaymentStatusErrors } from './EshopPaymentControllerCheckPaymentStatusErrors.gen';
import type { EshopPaymentControllerCheckPaymentStatusResponses } from './EshopPaymentControllerCheckPaymentStatusResponses.gen';
import type { EshopPaymentControllerGetPaymentStatusData } from './EshopPaymentControllerGetPaymentStatusData.gen';
import type { EshopPaymentControllerGetPaymentStatusErrors } from './EshopPaymentControllerGetPaymentStatusErrors.gen';
import type { EshopPaymentControllerGetPaymentStatusResponses } from './EshopPaymentControllerGetPaymentStatusResponses.gen';
import type { EshopPaymentControllerReversePaymentData } from './EshopPaymentControllerReversePaymentData.gen';
import type { EshopPaymentControllerReversePaymentErrors } from './EshopPaymentControllerReversePaymentErrors.gen';
import type { EshopPaymentControllerReversePaymentResponses } from './EshopPaymentControllerReversePaymentResponses.gen';
import type { Options } from './Options.gen';

export class EshopPaymentController {
    /**
     * Get a payment status.
     */
    public static getPaymentStatus<ThrowOnError extends boolean = false>(options: Options<EshopPaymentControllerGetPaymentStatusData, ThrowOnError>) {
        return (options.client ?? client).get<EshopPaymentControllerGetPaymentStatusResponses, EshopPaymentControllerGetPaymentStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/{id}/status',
            ...options
        });
    }
    
    /**
     * Update payment state of order if changed.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_ACCOUNT_NOT_VERIFIED** - Customer account is not verified.<br>
     * + **INVALID_ORDER_STATE** - Eshop order state is invalid or does not exist.
     */
    public static checkPaymentStatus<ThrowOnError extends boolean = false>(options: Options<EshopPaymentControllerCheckPaymentStatusData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPaymentControllerCheckPaymentStatusResponses, EshopPaymentControllerCheckPaymentStatusErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/{id}/check',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update payment state of order if changed.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_ACCOUNT_NOT_VERIFIED** - Customer account is not verified.<br>
     * + **CANNOT_REVERSE_PAYMENT** - CSOB payment cannot be reversed.
     */
    public static reversePayment<ThrowOnError extends boolean = false>(options: Options<EshopPaymentControllerReversePaymentData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPaymentControllerReversePaymentResponses, EshopPaymentControllerReversePaymentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/{id}/reverse',
            ...options
        });
    }
}
